<template>
    <!-- 平台成果  -->
    <div class="platform-outcomes">

        <div class="imgTitle">
            <img src="../../assets/img/新闻.png" alt="新闻png">
            <span>政策要闻</span>
        </div>
        <!-- 新闻展示div -->
        <div class="box">

            <div class="scroll_parent_box" @mouseenter="mEnter" @mouseleave="mLeave">
                <div class="scroll_list" :style="{ transform: `translate(0px,-${scrollTop}px)` }">

                    <div ref="scrollItemBox">
                        <div class="scroll_item" v-for="(item, index) in newsData" :key="index">
                            <div class="newsFont">
                                <img src="../../assets/img/little_news.png" alt="新闻小图标">
                            </div>
                            <div class="newsMessage">
                                <a :href="item.sciUrl" target="_blank">
                                    <p v-bind:style="{ fontWeight: 'bold' }">
                                        {{ item.sciName }}
                                    </p>
                                </a>
                            </div>
                        </div>
                    </div>

                    <div v-html="copyHtml"></div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
import axios from 'axios'
import config from '../../../config/ipConfig'

export default {
    data() {
        return {
            apiUrl:config.apiUrl,
            scrollTop: 0, //列表滚动高度
            speed: 70, //滚动的速度
            newsData: [
                
            ], //表示有多少个列表项
            copyHtml: '', //复制多一份防止滚动到后面出现空白
            msg: '',
            outcomes: {
                companyNum: '',
                financingNum: '',
                financingTotalAmount: ''
            },
        }
    },
    //同步执行的，意味着在该函数内的代码将在组件创建完成前立即执行
    //可以在该函数下完成一些初始化的工作
    created() {
        this.initData();
    },
    mounted() {
        // 如果列表数据是异步获取的，记得初始化完毕后再获取数据调用该方法
        //this.initScroll();
    },
    methods: {
        //获取政务新闻条例
        initData() {
            // console.log(this.apiUrl);
            axios.get( this.apiUrl+'/index/sciindexnews/page?limit=14&page=1&order=desc&orderField=date').then((res) => {
                // console.log(res)
                for (let index = 0; index < res.data.data.list.length; index++) {
                    if(res.data.data.list[index].sciName.length>=60){
                        // console.log(res.data.data.list[index].sciName)
                        res.data.data.list[index].sciName=res.data.data.list[index].sciName.substring(0, 40)+"....";
                    }
                }
                this.newsData = res.data.data.list
                //初始化在获取数据后再调用
                this.initScroll();
            }).catch((err) => {
                console.log(err)
                console.log('请求出错')
            })
        },
        //以下是实现滚动的
        initScroll() {
            this.$nextTick(() => {
                this.copyHtml = this.$refs.scrollItemBox.innerHTML
                this.startScroll()
            })
        },
        // 鼠标移入停止滚动
        mEnter() {
            clearInterval(this.timer);
        },
        // 鼠标移出继续滚动
        mLeave() {
            this.startScroll()
        },
        // 开始滚动
        startScroll() {
            //添加this指向，告诉他是自己的这个time，如果不加的话，没办法识别了
            this.timer = setInterval(this.scroll, this.speed);
        },
        // 滚动处理方法
        scroll() {
            //用于复制上一次出现的所有数据，因为在使用axios之后滚动数据只会滚动一次，也就是说没有调用copyHtml所以退而求其次用这个
            //this.copyHtml = this.$refs.scrollItemBox.innerHTML

            this.scrollTop++
            // 获取需要滚动的盒子的高度
            let scrollItemBox = this.$refs.scrollItemBox.offsetHeight;
            // 当判断滚动的高度大于等于盒子高度时，从头开始滚动
            if (this.scrollTop >= scrollItemBox) {
                this.scrollTop = 0
            }
        },


    },

}
</script>

<style scoped>

a {
    /* 设置字体颜色 */
    color:aliceblue;
    /* text-shadow: 0.2px 0.2px 1px white; */
}

.newsMessage {
    padding-left: 7%;
}

.newsFont {
    text-align: left;
    padding-left: 2%;
}

.scroll_parent_box {
    width: 90%;
    height: 100%;
    /*边框*/
    /* border: 1px solid #ebeef5;  */
    overflow: hidden;
    box-sizing: border-box;
    padding: 0 10px;
}

.scroll_list {
    /* color: #e9e4da; */
    transition: all 0ms ease-in 0s
}

.scroll_item {
    height: 40px;
    line-height: 40px;
    /* text-align: center; */
    font-size: 14px;
}


.platform-outcomes {
    width: 1920px;
    height: 600px;
    background-image: url("../../assets/img/new/政策要问bg.jpg");
    /* background-image: url("../assets/img/chengguobg1.jpg"); */
    background-repeat: no-repeat;
    background-size: 100%;
    /* background-position: center; */
    padding-left: 300px;
    padding-top: 80px;
}

.platform-outcomes .imgTitle {
    padding-left: 10px;
}

.platform-outcomes .imgTitle span {
    font-size: 25px;
    font-weight: 700;
    /* color: #313233; */
    color: aliceblue;
    margin-left: 10px;
    margin-top: 15px;
}

.platform-outcomes .box {
    padding-left: 10%;
    /* box内的滚动条向左偏移10% */
    width: 1280px;
    height: 380px;
    /* background: skyblue; */
    /* background: white; */
    /* background-color: rgba(0, 0, 255, 0.5); */
    float: left;
    margin-top: 35px;
    margin-right: 10px;
    /* border-top: 8px solid #d6ba83; */
    /* border-bottom: 8px solid #d6ba83; */
}

.platform-outcomes .box ul {
    margin-left: 80px;
    margin-right: 80px;
    margin-top: 25px;
    /* background:  white; */
}

.platform-outcomes .box ul span {
    font-size: 30px;
    font-weight: 500;
    color: #cc4f4f;
}</style>


// WEBPACK FOOTER //
// src/components/Department_Industry_Finance/GovernmentNews.vue